import { apiGet } from '@/shared/utils/requestBuilder';
import { parseApiResponse } from '@/shared/utils/apiResponse';

import type {
  EscritorioLookup,
  UsuarioLookup,
  LookupPaginatedResult,
  LookupParams,
} from '../../types/lookups';

const BASE_URL = '/admin/lookups';

function buildQuery(params: LookupParams & { escritorioId?: string }): string {
  const query = new URLSearchParams();
  if (params.search) query.set('search', params.search);
  if (params.page) query.set('page', String(params.page));
  if (params.limit) query.set('limit', String(params.limit));
  if (params.escritorioId) query.set('escritorioId', params.escritorioId);
  const qs = query.toString();
  return qs ? `?${qs}` : '';
}

export const adminLookupsService = {
  async escritorios(params: LookupParams = {}): Promise<LookupPaginatedResult<EscritorioLookup>> {
    const response = await apiGet(`${BASE_URL}/escritorios${buildQuery(params)}`);
    return parseApiResponse<LookupPaginatedResult<EscritorioLookup>>(response);
  },

  async usuarios(
    params: LookupParams & { escritorioId?: string } = {},
  ): Promise<LookupPaginatedResult<UsuarioLookup>> {
    const response = await apiGet(`${BASE_URL}/usuarios${buildQuery(params)}`);
    return parseApiResponse<LookupPaginatedResult<UsuarioLookup>>(response);
  },
};
